export const general = {
	languages: {
		en: "Engelsk",
		sv: "Svensk",
		da: "Dansk",
		no: "Norsk",
	},
};
